module.exports = __webpack_public_path__ + "img/15.51b5d9ac.png";